import {C240DeviceStatusConstants} from "../redux_constants/c240_device_status.constant";


let InitialState = {
    server_up: true,
    data: null,
    queue_state: {ongoing: null, queue: []},
    scanner_state: {},
    machineStatus: undefined
}

export const c240DeviceStatusReducer = ( state = InitialState , action) => {
    switch(action.type){
        case C240DeviceStatusConstants.UPDATE_SERVER_STATE:
            return {
                ...state,
                server_up: action.server_up
            }
        case C240DeviceStatusConstants.UPDATE_DEVICE_STATUS_DATA:
            return {
                ...state,
                data: action.data
            }
        case C240DeviceStatusConstants.UPDATE_QUEUE_STATE:
            return {
                ...state,
                queue_state: action.queueState
            }
        case C240DeviceStatusConstants.UPDATE_SCANNER_STATE:
            return {
                ...state,
                scanner_state: action.scannerState
            }
        case C240DeviceStatusConstants.UPDATE_MACHINE_STATUS_BAR:
            return {
                ...state,
                machineStatus: action.machineStatus
            }
        default :
            return state
    }
}